<template>
    <div>

        <div v-if="showCompontent == true">

            <div class="panel panel-clinic">

                <div class="panel-heading collapsed" href="#form_review_updates" data-toggle="collapse">

                    <div class="arrow-down"></div>

                    <h2 class="panel-title">Ansökan om att uppdatera uppgifter</h2>

                </div>

                <div id="form_review_updates" class="panel-collapse collapse">

                    <div class="panel-body" v-if="panelIsOpen">

                        <p v-if="saved == false">Titta igenom och godkänn uppgifterna. I det gråa fältet visas den äldre
                            texten som är publicerad för tillfället, i textfältet visas ändringen. Om något behöver
                            justeras, ändra i textfältet innan du sparar.</p>

                        <div class="alert alert-success" v-if="saved == true">
                            Massörens uppgifter har uppdaterats.
                        </div>

                        <div v-for="(val, key) in input">

                            <div class="form-group oddevencol" v-if="key != 'id'">

                                <div v-if="key !== 'booking_presentation'">
                                    <label v-bind:for="key" class="control-label">{{ labels[key] }}</label>

                                    <div class="input-group" v-if="key != 'payment_type'">
                                        <span class="input-group-addon">{{ clinic[key] }}</span>
                                        <input type="text" v-model="input[key]" class="form-control">
                                    </div>

                                    <div class="input-group" v-if="key == 'payment_type'">
                                        <span class="input-group-addon" style="white-space: normal;">{{ accountType(clinic[key]) }}</span>

                                        <select v-model="input[key]" class="form-control">

                                            <option v-bind:value="1">Konto</option>
                                            <option v-bind:value="2">Bankgiro</option>
                                            <option v-bind:value="3">Plusgiro</option>

                                        </select>

                                    </div>
                                </div>

                                <div v-if="key === 'booking_presentation'">
                                    <div>
                                        <label class="control-label">Befintlig presentationstext</label>
                                        <div class="w-100 input-group-addon" style="white-space: normal; text-align:left; padding:16px; border-right:1px solid #ccc;">{{ clinic[key] }}</div>
                                        <div style="margin-top: 20px;">
                                            <label v-bind:for="key" class="control-label">Ny presentationstext ({{ input[key].length }}/250)</label>
                                            <textarea class="w-100 form-control" v-model="input[key]" maxlength="250" style="height: 150px;"></textarea>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row" style="margin-top: 40px;">
                            <div class="col-md-24">
                                <div v-show="clinic.previewPortrait">
                                    <presentation-portrait
                                        :clinic_id="clinic_id"
                                        :portrait="portrait"
                                        @upload="portraitUpload"
                                        @change="portraitChange"
                                    />
                                </div>
                                <div v-show="clinic.clinic_submitted_delete_portrait">
                                    <h3>Porträttsfoto</h3>
                                    <p>Massören har tagit bort bilden</p>
                                </div>
                            </div>
                            <div class="col-md-24">
                                <div v-show="clinic.previewLocations.length > 0">
                                    <presentation-location
                                        :clinic_id="clinic_id"
                                        :locations="locations"
                                        @upload="locationUpload"
                                        @remove="locationRemove"
                                        @reorder="locationReorder"
                                    />
                                </div>
                                <div v-show="clinic.clinic_submitted_delete_locations">
                                    <h3>Foton på mottagningen</h3>
                                    <p>Massören har tagit bort bilderna</p>
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-primary pull-right" style="margin-top:10px;" v-on:click="save()"
                                v-if="saved == false">
                            Godkänn och spara ändringar
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

import presentationPortrait from './formComponents/presentation-portrait'
import PresentationLocation from './formComponents/presentation-location'

import mixin from './mixin'

export default {

    components: {
        presentationPortrait,
        PresentationLocation
    },

    mixins: [mixin],

    props: {
        clinic: {
            required: true
        }
    },

    data () {
        return {
            clinic_id: this.clinic.id,
            input: {},
            labels: {
                name_clinic: 'Mottagningsnamn',
                name_person: 'Massörens namn',
                public_email: 'Epost som kund ser',
                public_phone: 'Mobilnr eller telefonnr som kund ser',
                booking_link: 'Länk till bokningstjänst  (visas på knapp i klippkort)',
                booking_info: 'Information om bokning (visas i klippkort)',
                booking_instructions: 'Instruktion för val av tjänst (visas i klippkort)',
                website_link: 'Länk till hemsida',
                facebook_link: 'Länk till sida på Facebook',
                hours_weekdays: 'Öppettider',
                billing_phone: 'Mobilnr för kontakt & demokort (kolla formatet +46XXXXXXXXX)',
                contact_phone: 'Telefon för kontakt',
                org_number: 'Organisationsnummer',
                payment_type: 'Konto för utbetalningar',
                payment_account: 'Kontonummer',
                payment_bank: 'Bank',
                payment_clearing: 'Clearing'
            },
            showCompontent: false,
            saved: false,
            portrait: this.clinic.previewPortrait,
            locations: this.clinic.previewLocations,
            panelIsOpen: false

        }
    },

    created () {
        const self = this

        if (self.clinic.clinic_submitted_values == null && this.portrait === null && this.locations.length === 0) {
            return null
        }

        const values = JSON.parse(self.clinic.clinic_submitted_values)

        _.forEach(values, function (value, key) {
            if (self.clinic[key] != value) {
                if ((self.clinic[key] == null && value != '') || self.clinic[key] != null) {
                    // self.input[key] = value

                    self.$set(self.input, key, value)
                }
            }

            console.log(self.input[key])
        })

        this.showCompontent = true

        console.log('values up for review')
        console.log(values)
    },

    mounted () {
        $('body').on('shown.bs.collapse', '#form_review_updates', () => {
            console.log('show the cropper')

            this.panelIsOpen = true
        })
        $('body').on('hidden.bs.collapse', '#form_review_updates', () => {
            console.log('hide the cropper')

            this.panelIsOpen = false
        })
    },

    methods: {

        accountType (id) {
            const types = { 1: 'Konto', 2: 'Bankgiro', 3: 'Plusgiro' }

            return types[id]
        },

        save: function () {
            const self = this

            console.log('save clinic submited values')

            const postData = self.input

            postData.id = self.clinic.id
            postData.acceptClinicSubmitedValues = true
            postData.portrait = this.portrait
            postData.locations = this.locations

            this.$http.post('/clinics/update', postData).then((response) => {
                console.log(response.body)
                console.log('updated clinic values')

                self.saved = true
                self.input = {}

                bus.$emit('refresh-data', 1)

                bus.$emit('notify', 'Massörens uppgifter har uppdaterats.')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        portraitUpload (image) {
            this.portrait = image
        },

        portraitChange (coordinates) {
            this.portrait.crop_width = coordinates.width
            this.portrait.crop_height = coordinates.height
            this.portrait.crop_left = coordinates.left
            this.portrait.crop_top = coordinates.top
        },

        locationUpload (image) {
            this.locations.push(image)
        },

        locationRemove (index) {
            this.locations.splice(index, 1)
        },

        locationReorder (newOrder) {
            this.locations = newOrder
        }

    }

}
</script>
